import React, { Component } from 'react';
import { Modal, Button, TextInput, Row, Icon } from 'react-materialize';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import SearchItemCarousel from './SearchItemCarousel';
import { loadVehicleData, generateAPIToken } from '../../brain2';
import { hasAccessToken } from '../../brainApi';
import { transformEngine } from '../VehicleEntry/YearMakeModelTab';
import {
  createVehicle,
  AUTOMOBILE_TABS,
  TAB_TO_TYPE,
} from '../../vehicleHelper';
import { tracRudderStackkEvent } from "../../helper";

class VehicleSelectionModal extends Component {
  constructor(props) {
    super(props);
    const {
      isVehicleOpen,
      onClose,
      vehicleData,
      dispatch,
      account,
      vehicle,
      vehicles,
      customerLocation,
      homeAddress,
      z3pConfiguration,
    } = props;

    this.handleBrandClick = this.handleBrandClick.bind(this);
    this.onSearchData = this.onSearchData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onClearSearchData = this.onClearSearchData.bind(this);

    const initialYmmDetails = {
      year: '',
      makeName: '',
      makeId: '',
      otherMake: '',
      modelName: '',
      modelId: '',
      otherModel: '',
      vehicleId: '',
      baseVehicleId: '',
      submodelId: '',
      submodelName: '',
      engine: transformEngine({}),
      color: '',
    };
    this.state = {
      searchResultList: vehicleData || [], // Stores the car list from API
      selectedCar: '', // Stores the selected car
      selectedQueryType: 'vehicle',
      ymmVehicleDetails: initialYmmDetails,
    };
  }

  searchVehicleDone = (vehicleData) => {
    this.props.completeVehicleSearch(vehicleData);
  };
  /* async componentDidMount() {
    // Fetch initial data on load
    const results = await loadVehicleData(""); // Empty query to get default results
    this.setState({ searchResultList: results });
  } */

  handleBrandClick(searchResult, isButton, isLastIndex) {
    this.setState({ selectedCar: searchResult.label });
    this.setState({ selectedQueryType: searchResult.action.queryType });
    /* this.onSearchData({ target: { value: searchResult.label } }); */
    console.log(searchResult.action.queryType);
    if (
      searchResult.action.queryType === undefined ||
      searchResult.action.queryType === ''
    ) {
      if (searchResult.action.type === 'SiteSearchResultActionLink') {
        this.handleActionLink(searchResult);
      }
      return;
    }
    loadVehicleData('', searchResult.label, searchResult.action.queryType).then(
      (data) => {
        if (
          data.siteSearchResultGroupList &&
          Array.isArray(data.siteSearchResultGroupList)
        ) {
          this.setState({ searchResultList: data.siteSearchResultGroupList }); // Store data in state
        }
      },
    );
  }

  onSearchData(event) {
    const { value } = event.target;
    this.setState({ selectedCar: value });
  }

  handleInputChange(event) {
    const newValue = event.target.value;
    this.setState({ selectedCar: newValue });
    loadVehicleData('', newValue, 'vehicle').then((data) => {
      if (
        data.siteSearchResultGroupList &&
        Array.isArray(data.siteSearchResultGroupList)
      ) {
        this.setState({ searchResultList: data.siteSearchResultGroupList }); // Store data in state
      }
    });
    // ✅ Call your function when the input changes
    /* this.onSearchData({ target: { value: newValue } }); */
  }

  onClearSearchData() {
    this.setState({ selectedCar: '' });
    loadVehicleData('', '', 'vehicle').then((data) => {
      if (
        data.siteSearchResultGroupList &&
        Array.isArray(data.siteSearchResultGroupList)
      ) {
        this.setState({ searchResultList: data.siteSearchResultGroupList }); // Store data in state
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vehicleData !== this.props.vehicleData) {
      this.setState({ searchResultList: this.props.vehicleData }, () => {});
    }
  }

  offersMultipleVehicleTypes() {
    const {
      available_vehicle_entry_tabs: availableTabs,
    } = this.props.z3pConfiguration;
    const automobileOnly = availableTabs.every((tab) =>
      AUTOMOBILE_TABS.includes(tab),
    );
    return !(availableTabs.length < 2 || automobileOnly);
  }

  handleActionLink(searchResult) {
    const { action } = searchResult;
    localStorage.setItem("ShopNowHyperLink", action.link.href);
    const customerId =
      hasAccessToken() && this.props.account
        ? this.props.account.customer_id
        : null;
    if (action.type !== 'SiteSearchResultActionLink') {
      return;
    }

    if (!this.offersMultipleVehicleTypes()) {
      const {
        available_vehicle_entry_tabs: availableTabs
      } = this.props.z3pConfiguration;
      this.props.dispatch({
        type: 'SELECT_VEHICLE_TYPE',
        vehicleType: TAB_TO_TYPE[availableTabs[0]],
      });
    }

    if (action.vehicleMetadata) {
      const { vehicleMetadata } = action;
      const { z3p_client_name } = this.props.z3pConfiguration;
      if (action.link.href) {
        const vehicleData = {
          year: vehicleMetadata.vehicleYear,
          make: vehicleMetadata.vehicleMake,
          model: vehicleMetadata.vehicleModel,
          trim: vehicleMetadata.vehicleTrim,
          input_method_type: vehicleMetadata.vehType,
        };
        tracRudderStackkEvent('Service_Vehicle_Info', {
          proname: z3p_client_name,
          form_name: 'Vehicle Details',
          vehicle_year: vehicleMetadata.vehicleYear,
          vehicle_make: vehicleMetadata.vehicleMake,
          vehicle_modal: vehicleMetadata.vehicleModel,
          vehicle_trim: vehicleMetadata.vehicleTrim,
        });
        createVehicle(
          vehicleData,
          customerId,
          this.props.dispatch,
          this.props.vehicles,
        ).then(() => {
          this.searchVehicleDone(vehicleData);
          // return browserHistory.push('/pricing/begin');
        });
      }
    }
  }

  render() {
    const { isVehicleOpen, onClose } = this.props;
    const { searchResultList, selectedCar } = this.state;

    const InnerContent = ({ item }) => {
      const key = item.label;
      return item.labelSegments.length > 0 ? (
        item.labelSegments.map((segment, i) => {
          // [WCS-1409] Hyphens will break the text if the first character
          // Convert to non-breaking hyphens if this happens.
          if (segment.label[0] === '-') {
            segment.label = segment.label.replace('-', '‑');
          }
          return (
            <span
              key={`${key}-${i}`}
              className={selectedCar.includes(segment.label) ? 'active' : ''}
            >
              {segment.label}
            </span>
          );
        })
      ) : (
        <span>{item.label}</span>
      );
    };
    return (
      <Modal
        open={isVehicleOpen}
        options={{
          inDuration: 400, // Animation duration
          outDuration: 400,
          startingTop: '100%', // Start from bottom
          dismissible: false
        }}
        className="search_bar_modal modal-bottom"
      >
        {/* Header with Close Button */}
        <div className="modal-header">
          <Button className="close-btn" onClick={onClose}>
            <Icon>close</Icon>
          </Button>
        </div>

        {/* Modal Content */}
        <div className="modal-body">
          {/* Search Box Inside Modal */}
          <TextInput
            id="vehicle-search"
            className="custom-search-input"
            variant="filled"
            type="search"
            label="Vehicle: "
            value={selectedCar}
            onChange={this.handleInputChange} // ✅ Allows typing
            onSearch={this.onSearchData}
          />
          <Button
            variant="text"
            className="clear_search_input"
            onClick={this.onClearSearchData}
          >
            Clear
          </Button>
          {/* Most Popular Brands */}
          {searchResultList.map((items, index) => (
            <Row className="main-box">
              <h6>{items.label}</h6>
              {items.label === '' && (
                <ul data-testid="search-results">
                  {items.siteSearchResultList.map((item, index) => {
                    const lastIndex = item.type === 'SiteSearchResultTextItem';

                    return (
                      <li className="listItem" key={`${item.label}_${index}`}>
                        <button
                          className="itemButton"
                          onClick={() =>
                            this.handleBrandClick(item, true, lastIndex)
                          }
                        >
                          <InnerContent item={item} />
                        </button>
                        {item.detailLabel && (
                          <div className="secondaryItemDisplay">
                            {item.detailLabel}
                          </div>
                        )}
                        {item.detailLabel && (
                          <div className="secondaryItemDisplay">
                            {item.detailLabel}
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              {items.label === 'All' && (
                <ul data-testid="search-results">
                  {items.siteSearchResultList.map((item, index) => {
                    const lastIndex = item.type === 'SiteSearchResultTextItem';

                    return (
                      <li className="listItem" key={`${item.label}_${index}`}>
                        <button
                          className="itemButton"
                          onClick={() =>
                            this.handleBrandClick(item, true, lastIndex)
                          }
                        >
                          <InnerContent item={item} />
                        </button>
                        {item.detailLabel && (
                          <div className="secondaryItemDisplay">
                            {item.detailLabel}
                          </div>
                        )}
                        {item.detailLabel && (
                          <div className="secondaryItemDisplay">
                            {item.detailLabel}
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              {items.label === 'Most Popular' && (
                <SearchItemCarousel
                  items={items}
                  handleBrandClick={this.handleBrandClick}
                />
              )}
            </Row>
          ))}
        </div>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    account: state.ui.account,
    customerLocation: state.ui.customerLocation,
    homeAddress: state.ui.homeAddress,
    vehicle: state.ui.pricing,
    vehicles: state.ui.vehicles,
    z3pConfiguration: state.ui.z3pConfiguration,
  };
}
export default connect(mapStateToProps, null)(VehicleSelectionModal);
